module.exports = __webpack_public_path__ + "static/media/WordifyMe-1.d120e8ad.jpg";